import type { PatchModel } from "./patch"

export interface ActionSummary {
  id: string
  type: "action-summary"
  attributes: {
    name: string
    title: string
    titleForAnalytics: string
    desription: string
    serverReceivedAt: string
  }
  meta: {}
}

export interface ActionDoc {
  id: string
  type: "action"
  attributes: ActionDocAttributes
  relationships: ActionDocRelationships
}

export interface ActionDocAttributes {
  name: string
  patches: Array<PatchModel>
  narrative: any
  attemptCount: number
  sync: {
    status: string
    failureReason: string | null
    hasFailed: boolean
    attemptCount: number
    failureCount: number
    retryAt: Date | null
    isUserFacing: boolean
  }
  timing: {
    clientCreatedAt: string
    timeZone: string
    clientSentAt: Date | null
    serverReceivedAt: Date | null
    secondsSinceLastClientAction: number
    fullStorySessionUrl: string | null
  }
  order: {
    amongAllClientActions: number
    amongPublishedClientActions: null | number
    followsPublishedActionId: null | string
  }
}

export interface ActionDocRelationships {
  user: { data: { id: string; type: "user" } }
  session: { data: { id: string; type: "session" } }
}

export function generateActionDoc(
  id: string,
  actionName: string,
  patches: any[] | null,
  narrative: any,
  userId: string,
  sessionId: string,
  sequenceNumber: number,
  secondsSinceLastClientAction: number,
  clientCreatedAt: string,
  fullStorySessionUrl: string | null,
  isUserFacing: boolean,
): ActionDoc {
  return {
    id: id,
    type: "action",
    attributes: {
      name: actionName,
      patches: patches || [],
      narrative: narrative || { context: {} },
      attemptCount: 0,
      sync: {
        status: "waiting",
        failureReason: null,
        hasFailed: false,
        attemptCount: 0,
        failureCount: 0,
        retryAt: null,
        isUserFacing: isUserFacing,
      },
      timing: {
        clientCreatedAt: clientCreatedAt,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        clientSentAt: null,
        serverReceivedAt: null,
        secondsSinceLastClientAction: secondsSinceLastClientAction,
        fullStorySessionUrl: fullStorySessionUrl,
      },
      order: {
        amongAllClientActions: sequenceNumber,
        amongPublishedClientActions: null,
        followsPublishedActionId: null,
      },
    },
    relationships: {
      user: { data: { id: userId, type: "user" } },
      session: { data: { id: sessionId, type: "session" } },
    },
  }
}
